import ReactOnRails from 'react-on-rails/client';

// Keep track of whether the initial page load has already happened
let isInitialServerLoad = true;

/**
 * Safely prepares and forces React on Rails components to remount.
 */
export function remountReactComponents(event) {
  // If it's a Turbo navigation (either clicking a link or pressing Back),
  // it is NOT a raw initial server render.
  const isTurboNavigation = !isInitialServerLoad || event.type === 'turbo:render';

  if (isTurboNavigation) {
    document.querySelectorAll('.js-react-on-rails-component').forEach((scriptEl) => {
      const domId = scriptEl.getAttribute('data-dom-id');
      if (!domId) return;

      const domNode = document.getElementById(domId);
      if (!domNode || domNode.closest('[data-turbo-permanent]')) return;

      // 1. FORCE Client-Side Rendering: Strip the server hydration flag completely
      scriptEl.removeAttribute('data-react-hydrate');

      // 2. Clear out any HTML content so React 18 doesn't try to match elements
      if (domNode.innerHTML !== '') {
        domNode.innerHTML = '';
      }
    });
  }

  // Set this to false after the very first execution loop completes
  isInitialServerLoad = false;

  // Trigger React on Rails to execute its mounting logic safely
  if (typeof ReactOnRails !== 'undefined') {
    ReactOnRails.reactOnRailsPageLoaded();
  }
}

// Reset our server-load flag if the user does a full browser refresh (F5)
document.addEventListener('DOMContentLoaded', () => {
  isInitialServerLoad = true;
});

// Re-mount components perfectly when navigating or restoring cached pages
document.addEventListener('turbo:render', remountReactComponents);
document.addEventListener('turbo:load', remountReactComponents);